import { Hero } from '../components/Hero'

export function HomePage() {
  return <Hero />
}
